import "../styles/cuadros-turnos.css";
import { useContext } from "react";

import { Spinner } from "reactstrap";
import FormCopiarCuadroTurnos from "../components/form-copiar-cuadro-turnos";

import useModal from "../../../../core/hooks/use-modal";
import CuerpoTablaCuadrosTurnos from "../components/cuerpo-tabla-cuadros-turnos";
import CabeceraTablaCuadrosTurnos from "../components/cabecera-tabla-cuadros-turnos";

import ModalConvenciones from "../components/CabeceraCuadrosTurnos/SedesConvenciones/modal-convenciones";
import { TurnosConvencionesProvider } from "../../store/modal-convenciones-context";
import CuadroTurnosContext from "../../store/cuadro-turnos-context";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";

import CabeceraCuadrosTurnos from "../components/CabeceraCuadrosTurnos/cabecera-cuadros-turnos";
import FormCambiarSubArea from "../components/form-cambiar-sub-area";
import { SubAreasPersonaProvider } from "../../../Personas/store/sub-areas-context";
import swal from "sweetalert";
import { sweetAl } from "../../../../core/helpers/message-helper";
import { eliminarCuadroTurnosPorPersona } from "../../services/nomina-cuadro-turnos";
import { inactivarPersona } from "../../../Personas/services/personas-service";
import { useEffect } from "react";
import OpcionesTurnos from "../components/OpcionesTurnos/opciones-turnos";
import useTurno from "../../../../core/hooks/use-turno";
import OpcionesActividades from "../components/OpcionesActividades/opciones-actividades";
import useOpciones from "../../../../core/hooks/use-opciones";

const CuadroTurnos = () => {
    const { vaciarTurnosSeleccionados } = useTurno();
    const opcionesTurnos = useOpciones("turnos");
    const opcionesActividades = useOpciones("actividades");

    const { isLoading, dataCuadroTurnos, getCuadroTurnos, filtros } =
        useContext(CuadroTurnosContext);

    const modalCopiarTurnos = useModal({ title: "Copiar Turnos" });
    const modalConvenciones = useModal({ title: "Convenciones" });
    const modalCambioDeSubArea = useModal({ title: "Modificar sub area" });

    const copiarEmpleadoCuadroTurno = (personaId) => {
        modalCopiarTurnos.open({
            data: { personaId },
            title: "Crear",
        });
    };

    const cambiarSubAreaColaborador = (personaId) => {
        modalCambioDeSubArea.open({
            data: { personaId },
            title: "Crear",
        });
    };

    useEffect(() => {
        // Crear variable en local storage para seleccion de turnos en el cuadro
        vaciarTurnosSeleccionados();

        const ocultarCuadrosOpciones = () => {
            opcionesTurnos.ocultarCuadroOpciones();
            opcionesActividades.ocultarCuadroOpciones();
        };

        const onTeclaEscape = (e) => {
            if (e.key === "Escape") ocultarCuadrosOpciones();
        };

        window.addEventListener("scroll", ocultarCuadrosOpciones);
        window.addEventListener("keydown", onTeclaEscape);

        return () => {
            window.removeEventListener("scroll", ocultarCuadrosOpciones);
            window.removeEventListener("keydown", onTeclaEscape);
        };
    }, []);

    useEffect(() => {
        const ocultarCuadrosOpciones = () => {
            opcionesTurnos.ocultarCuadroOpciones();
            opcionesActividades.ocultarCuadroOpciones();
        };

        const tabla = document.getElementById("div-tabla-cuadros-turnos");
        tabla && tabla.addEventListener("scroll", ocultarCuadrosOpciones);

        return () =>
            tabla &&
            tabla.removeEventListener("scroll", ocultarCuadrosOpciones);
    }, [dataCuadroTurnos]);

    const eliminarCuadroDeTurnosPorPersona = async (personaId) => {
        try {
            const value = await swal({
                title: "Confirmación",
                text: "¿Seguro que desea eliminar este cuadro de turnos?",
                icon: "info",
                buttons: {
                    cancelar: { text: "Cancelar", className: "btn-danger" },
                    inactivar: { text: "Inactivar", className: "btn-success" },
                },
            });

            if (value === "cancelar") {
                sweetAl.warning("No se eliminó el cuadro de turnos");
            } else if (value === "inactivar") {
                const resp = await eliminarCuadroTurnosPorPersona(
                    filtros.startDate,
                    filtros.endDate,
                    filtros.sedeAreaLider,
                    personaId
                );

                if (!resp.status) {
                    sweetAl.error(
                        "Ha ocurrido un error eliminando el cuadro de turnos"
                    );
                } else {
                    sweetAl.success(
                        "El cuadro de turnos fue eliminado correctamente"
                    );
                    getCuadroTurnos();
                }
            }
        } catch (error) {
            console.error("Error al mostrar el cuadro de diálogo", error);
        }
    };

    const inactivarPersonaCuadro = async (personaId) => {
        try {
            const value = await swal({
                title: "Confirmación",
                text: "¿Seguro que desea eliminar esta persona?",
                icon: "info",
                buttons: {
                    cancelar: { text: "Cancelar", className: "btn-danger" },
                    inactivar: { text: "Inactivar", className: "btn-success" },
                },
            });

            if (value === "cancelar") {
                sweetAl.warning("No se eliminó el la persona");
            } else if (value === "inactivar") {
                const resp = await inactivarPersona(personaId);

                if (!resp.status) {
                    sweetAl.error("Ha ocurrido un error eliminando la persona");
                } else {
                    sweetAl.success("La persona fue eliminada correctamente");
                    getCuadroTurnos();
                }
            }
        } catch (error) {
            console.error("Error al mostrar el cuadro de diálogo", error);
        }
    };

    const onEmpleadoAccion = (idEmpleado, accion) => {
        if (accion === "copiar") copiarEmpleadoCuadroTurno(idEmpleado);
        if (accion === "cambioArea") cambiarSubAreaColaborador(idEmpleado);
        if (accion === "eliminarTurnos")
            eliminarCuadroDeTurnosPorPersona(idEmpleado);
        if (accion === "personasInactivar") inactivarPersonaCuadro(idEmpleado);
    };

    return (
        <>
            <TurnosConvencionesProvider>
                <ContentWrapper>
                    <div className="content-heading">
                        <div>NÓMINA / Creación Cuadro De Turnos</div>
                    </div>

                    <CabeceraCuadrosTurnos
                        modalConvenciones={modalConvenciones}
                    />

                    <div
                        className="table-responsive"
                        id="div-tabla-cuadros-turnos"
                        style={{
                            height: "96vh",
                            overflowY: "auto",
                            width: "100%",
                            fontSize: "10px",
                            lineHeight: "10px",
                        }}
                    >
                        {isLoading ? (
                            <div
                                className="container-fluid w-100 d-flex justify-content-center align-items-center"
                                style={{ height: "50vh" }}
                            >
                                <Spinner />
                            </div>
                        ) : (
                            <table
                                className="table table-hover"
                                id="cuadro-turnos"
                            >
                                <CabeceraTablaCuadrosTurnos
                                    area={dataCuadroTurnos.area}
                                    fechasCuadroTurnos={
                                        dataCuadroTurnos.fechasCuadroTurnos
                                    }
                                />
                                <CuerpoTablaCuadrosTurnos
                                    onEmpleadoAccion={onEmpleadoAccion}
                                    dataCuadroTurnos={dataCuadroTurnos}
                                />
                            </table>
                        )}
                    </div>

                    <FormCopiarCuadroTurnos
                        endDate={filtros.endDate}
                        modalState={modalCopiarTurnos}
                        startDate={filtros.startDate}
                        cuadroTurnos={dataCuadroTurnos.cuadroTurnos}
                        onCoppied={() => {
                            modalCopiarTurnos.close();
                            getCuadroTurnos();
                        }}
                    />
                    <SubAreasPersonaProvider>
                        <FormCambiarSubArea
                            modalState={modalCambioDeSubArea}
                            onCambioArea={() => {
                                modalCambioDeSubArea.close();
                                getCuadroTurnos();
                            }}
                        />
                    </SubAreasPersonaProvider>

                    <ModalConvenciones modalState={modalConvenciones} />
                </ContentWrapper>
            </TurnosConvencionesProvider>
            <table
                id="tablaConvenciones"
                className="table"
                style={{ display: "none" }}
            >
                <thead>
                    <tr>
                        <th>Sigla</th>
                        <th>Horas</th>
                        <th>Horario</th>
                        <th>Receso</th>
                        <th>Comentario</th>
                    </tr>
                </thead>
                <tbody id="bodyTablaConvenciones"></tbody>
            </table>
            <OpcionesTurnos />
            <OpcionesActividades sedeAreaLider={filtros.sedeAreaLider} />
        </>
    );
};

export default CuadroTurnos;
